/**
 * Format a phone number to (XXX)-XXX-XXXX format
 * @param phone - The phone number to format
 * @returns Formatted phone number or original if invalid
 */
export function formatPhoneNumber(phone: string): string {
  // Remove all non-numeric characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Check for placeholder phone number from migration
  if (cleaned === '0000000000') {
    return ''; // Return empty string for placeholder phones
  }
  
  // Handle 11-digit US numbers with leading country code 1
  if (cleaned.length === 11 && cleaned[0] === '1') {
    return `(${cleaned.slice(1, 4)})-${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }

  // Check if we have 10 digits
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)})-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  
  // Return original if not valid
  return phone;
}

/**
 * Remove formatting from a phone number, keeping only digits
 * @param phone - The formatted phone number
 * @returns Phone number with only digits
 */
export function unformatPhoneNumber(phone: string): string {
  return phone.replace(/\D/g, '');
}

/**
 * Format phone number as user types
 * @param value - The input value
 * @returns Formatted phone number
 */
export function formatPhoneNumberInput(value: string): string {
  // Remove all non-numeric characters
  const cleaned = value.replace(/\D/g, '');
  
  // Apply formatting based on length
  if (cleaned.length <= 3) {
    return cleaned;
  } else if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 3)})-${cleaned.slice(3)}`;
  } else if (cleaned.length <= 10) {
    return `(${cleaned.slice(0, 3)})-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  } else {
    // Don't allow more than 10 digits
    return `(${cleaned.slice(0, 3)})-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  }
}